import { render, staticRenderFns } from "./EditReferenceDialog.vue?vue&type=template&id=5c2dfc44&scoped=true"
import script from "./EditReferenceDialog.vue?vue&type=script&lang=js"
export * from "./EditReferenceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditReferenceDialog.vue?vue&type=style&index=0&id=5c2dfc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2dfc44",
  null
  
)

export default component.exports